export default __webpack_public_path__ + "static/media/idea.ecb74650.svg";